<script>

import Layout from '@layouts/main.vue'
import UserItem from '@components/user-item.vue'
import firebase from 'firebase/app'
import 'firebase/firestore'

export default {
  page: {
    title: 'Users',
    meta: [{ name: 'description', content: 'The Users page.' }],
  },
  components: { Layout, UserItem },
  data() {
    return {
      addUserData: {
        name: null,
        candidate: null,
        password: null,
        accessLimit: 16,
      },
    }
  },
  computed: {
    users() {
      return this.$store.getters['qa/getUsers']
    },
    loggedInUser() {
      return this.$store.getters['qa/getUser']
    },
  },
  watch: {},
  mounted() {
    this.$store.dispatch('qa/fetchUsers')
  },
  methods: {
    signInWithGoogle() {
      // limit signin to @outfit7.com domain (this can be overridden - it's not a security, but a cosmetical feature!)
      // true security limitation is in cloud firestore security rules setup!
      const provider = new firebase.auth.GoogleAuthProvider()
      provider.setCustomParameters({
        hd: 'outfit7.com',
      })
      firebase
        .auth()
        .signInWithPopup(provider)
        .then((data) => {})
        .catch((err) => {
          console.log(err)
        })
    },
    save() {
      this.$store.dispatch('qa/saveUser', this.addUserData)
      this.addUserData.name = null
      this.addUserData.candidate = null
      this.addUserData.password = null
    },
    formatDate(date) {
      var options = {
        day: 'numeric',
        month: 'long',
        year: 'numeric',
      }
      if (date !== undefined) {
        return date.toLocaleDateString('en-GB', options)
      } else {
        return false
      }
    },
  },
}
</script>

<template>
  <Layout>
    <div v-if="!loggedInUser.loggedIn" class="login-container">
      <span class="md-title">QA Game Test - Sign in</span>
      <div :class="['googlelogin']" @click="signInWithGoogle"
        >Sign in with Google</div
      >
    </div>
    <div v-else class="container">
      <h1 class="md-title">Users</h1>
      <ul class="userlist">
        <li class="useritem">
          <div class="basicinfo">
            <div class="md-list-item-text">
              <span><strong>Name</strong></span>
            </div>
            <div class="md-list-item-text">
              <span><strong>Candidate</strong></span>
            </div>
            <div class="md-list-item-text">
              <span><strong>Password</strong></span>
            </div>
            <div class="md-list-item-text">
              <span><strong>Limit</strong></span>
            </div>
            <div class="md-list-item-text">
              <span><strong>Session Start</strong></span>
            </div>
            <div class="md-list-item-text">
              <span><strong>Session Status</strong></span>
            </div>
          </div>
        </li>
        <UserItem v-for="(item, i) in users" :key="i" :item="item"></UserItem>
      </ul>
      <form class="container2" @submit.prevent="save">
        <span class="md-title">Add user</span>
        <div class="editusercontent">
          <md-field>
            <label>Name (spaces not allowed)</label>
            <md-input v-model="addUserData.name" pattern="^\S*$" title="Whitespace characters are not allowed"></md-input>
          </md-field>
          <md-field>
            <label>Candidate</label>
            <md-input v-model="addUserData.candidate"></md-input>
          </md-field>
          <md-field>
            <label>Password (spaces not allowed)</label>
            <md-input v-model="addUserData.password" pattern="^\S*$" title="Whitespace characters are not allowed"></md-input>
          </md-field>
          <md-field>
            <label>Access Time Limit (in minutes)</label>
            <md-input v-model="addUserData.accessLimit"></md-input>
          </md-field>
        </div>
        <md-button class="md-primary" type="submit">Save</md-button>
      </form>
    </div>
  </Layout>
</template>

<style lang="scss" scoped>
@import '@design';

.container {
  min-height: calc(100vh - 150px);

  .md-title {
    padding-left: 25px;
  }

  .userlist {
    padding-inline: 25px;
    margin-bottom: 3rem;
  }

  .useritem {
    display: block;
    list-style-type: none;

    .basicinfo {
      display: grid;
      grid-template-columns: auto 200px 200px 100px 200px 200px 100px;
      align-items: center;
    }

    .md-list-item-text {
      margin-block: 0.25rem;
    }

    .md-list-item-content {
      align-items: normal;
    }
  }
}

.editusercontent {
  min-width: 500px;
  padding: 0 25px;
}

.login-container {
  .md-title {
    display: inline-block;
    width: 100%;
    margin: 50px 0 50px 0;
    text-align: center;
  }

  .googlelogin {
    display: block;
    width: 230px;
    height: 56px;
    margin: 0 auto;
    text-indent: -9999px;
    background: url('../../assets/images/btn_google_signin_light_normal.png');
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
  }
}
</style>
